import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {IDatasetFileManagerCategoryItems, IFormFileItem, IFormFileUploadDialog} from '../../interface/form-structure';
import {FileManagerComponent} from '../Dialogs/file-manager/file-manager.component';
import {HttpFormService} from '../../services/formServices';
import {GlobalObjectService} from '../../class/global-obj';
import {IHttpSetting} from '../../interface/dataset-params';
import {ActionFlag} from '../../interface/component';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';

@Component({
    selector: 'noos-file-button',
    templateUrl: './file-button.component.html',
    styleUrls: ['./file-button.component.scss']
})
export class FileButtonComponent implements OnInit, AfterViewInit {


    @Input()
    FORM_ID = 0;

    @Input()
    masterDatasetId = 0;

    @Input()
    actionFlag: ActionFlag = ActionFlag.NEW;

    @Input()
    FORM_GUID = 0;

    @Input()
    fileData: IFormFileItem[] = [];

    @Input()
    btnText = 'Dosyalar';

    @Input()
    setting: IHttpSetting;

    isFileUpload = false;

    fileManagerTypes: IDatasetFileManagerCategoryItems[];

    @Output()
    saveFile = new EventEmitter<IFormFileItem[]>();

    @Output()
    fileControlResult = new EventEmitter<boolean>();

    constructor(private dialog: MatDialog, private formService: HttpFormService) {
        const setting = GlobalObjectService.getVar('setting');
        if (setting) {
            this.setting = setting;
        }
    }

    ngOnInit() {
    }

    ngAfterViewInit(): void {
        this.formService.formFileManagerStructure(this.setting, this.FORM_ID, this.masterDatasetId).subscribe(response => {
            if (response.complete && response.data) {
                this.isFileUpload = ((response.data.is_new_record_enable || false) && this.actionFlag === ActionFlag.NEW) ||
                    this.actionFlag === ActionFlag.EDIT;
                this.fileManagerTypes = response.data.file_category_items || [];
                this.controlFiles();
            }
        }, error1 => {
            this.isFileUpload = false;
        });
    }

    controlFiles() {
        this.fileManagerTypes.forEach(t => {
            if (t.require_is_new && this.actionFlag === ActionFlag.NEW) {
                const fileIs = this.fileData.filter(c => c.file_type_id === t.file_category_code);
                if (fileIs.length === 0) {
                    this.fileControlResult.emit(false);
                    return;
                }
            }
        });

        this.fileControlResult.emit(true);
    }

    onOpenFileDialog() {
        const dialogConfig = new MatDialogConfig();
        const dialogData: IFormFileUploadDialog = {
            FORM_ID: this.FORM_ID,
            DATASET_ID: this.masterDatasetId,
            FORM_GUID: this.FORM_GUID,
            fileCategoryItems: this.fileManagerTypes,
            formFileData: this.fileData
        };
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = false;
        dialogConfig.width = '750px';
        dialogConfig.panelClass = 'formDialog';
        dialogConfig.data = dialogData;

        const dialogRef = this.dialog.open(FileManagerComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((result: IFormFileUploadDialog) => {
            if (result) {
                this.saveFile.emit(result.formFileData);
                this.controlFiles();
            }
        });

    }

}
